enum StatusCode {
    PENDING = 'PENDING',
    COMPLETE = 'COMPLETE',
    ERROR = 'ERROR',
    NONE = 'NONE',
}

export default StatusCode;